<template>
	<div class="simulador_container">		
		<stepper :step='step'></stepper>
		<simulador-passo-consorcio v-show='step==1' @proximo='gravarDadosConsorcio'></simulador-passo-consorcio>
		<simulador-passo-resultado :lead='lead' v-show='step==2' @anterior='step=1' @reiniciar='reiniciar'></simulador-passo-resultado>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				step:1,
				dadosConsorcio:{},
				dadosPessoais:{},
				lead:{},
				cartasCompativeis:[]
			}
		},
		mounted(){
			this.$gtag.event('pageView', { page: window.location.pathname })
		},
		methods:
		{
			gravarDadosConsorcio({consorcio, dadosLead}){

				this.dadosConsorcio = consorcio;				

				this.dadosPessoais = dadosLead;

				const lead = {
					tipo_consorcio : this.dadosConsorcio.tipo_consorcio,
					tipo_calculo: this.dadosConsorcio.tipo_calculo,
					valor: this.dadosConsorcio.range_valor,
					nome: this.dadosPessoais.nome,
					email: this.dadosPessoais.email,
					telefone: this.dadosPessoais.telefone,
					cep: this.dadosPessoais.cep
				};

				axios.post('/api/apifront/gravarlead',lead)
					.then((data)=>{
						this.lead = data.data;						
						this.step = 2;											
						
						fbq('track', 'Lead');
						this.$gtag.event('generate_lead', { 
							lead_name: this.dadosPessoais.nome,
							lead_email: this.dadosPessoais.email,
							lead_telephone: this.dadosPessoais.telefone,
						});
					})
					.catch((error)=>{
						console.log(error);
						Swal.fire('Dados não processados','Problemas ao processar sua simulação. Tente novamente mais tarde','error');
						return;
					});				
			},

			reiniciar(){
				this.step=1;
			}
		}
	}

</script>
